@import '~style-sheet-helpers/core.less';

.remove-hold-modal {
  width: 450px;
}

.remove-hold-modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 16px 64px;
  font-size: 14px;
  line-height: 1.5;
}

.loading-indicator {
  height: 60px;
}

.remove-hold-modal-footer {
  .remove-hold-button {
    margin-left: 8px;
  }
}
